<template>
  <div class="page" style="margin-left: 200px">
    <el-card class="card" :body-style="{ padding: '20px 20px 0 20px' }">
      <div class="header">
        <span
          :class="showView == 'statistic' ? 'showViewClass' : 'viewClass'"
          @click="showView = 'statistic'"
          >{{ $t('DomesticWarehousing.DataStatistics') }}</span
        >
        <div
          style="
            width: 2px;
            height: 16px;
            margin: 3px 8px;
            background-color: #9c9c9c;
          "
        />
        <span
          :class="showView == 'inQuery' ? 'showViewClass' : 'viewClass'"
          @click="showView = 'inQuery'"
          >{{ $t('DomesticWarehousing.InboundQuery') }}</span
        >
        <div
          style="
            width: 2px;
            height: 16px;
            margin: 3px 8px;
            background-color: #9c9c9c;
          "
        />
        <span
          :class="showView == 'outQuery' ? 'showViewClass' : 'viewClass'"
          @click="showView = 'outQuery'"
          >{{
            jobType == 'DC'
              ? $t('DomesticWarehousing.OutboundQuery')
              : $t('DomesticWarehousing.StuffingInquiry')
          }}</span
        >
        <div
          v-if="jobType === 'DC'"
          style="
            width: 2px;
            height: 16px;
            margin: 3px 8px;
            background-color: #9c9c9c;
          "
        />
        <span
          v-if="jobType === 'DC'"
          :class="showView == 'stock' ? 'showViewClass' : 'viewClass'"
          @click="showView = 'stock'"
          >{{ $t('DomesticWarehousing.InventoryInquiry') }}</span
        >
      </div>
      <div class="mtf1">
        <span>{{ $t('DomesticWarehousing.OrderInquiry') }}</span>
        <el-select
          v-model="jobType"
          class="elSelect"
          size="small"
          @change="changeJobType"
          :popper-append-to-body="true"
        >
          <el-option
            v-for="(item, index) in selectList"
            :key="index"
            :value="item.value"
            :label="item.label"
          />
        </el-select>
        <div
          v-show="showView !== 'statistic'"
          class="mtf1 scription-center"
          @click="showScription()"
        >
          <i class="el-icon-collection" style="margin-right: 4px"></i
          >{{ $t('DomesticWarehousing.SubscriptionCenter') }}
        </div>
      </div>
    </el-card>
    <!-- <div v-if="showView===1">
      <DataStatistics
        :job-type.sync="jobType"
        :customer-code.sync="customerCode"
      />
    </div> -->
    <div v-if="jobType === 'DC' && showView == 'statistic'">
      <DCDataStatistics
        :job-type.sync="jobType"
        :customer-code.sync="customerCode"
      />
    </div>
    <div v-if="jobType === 'DC' && showView == 'inQuery'">
      <DCInboundSearch
        :job-type.sync="jobType"
        :customer-code.sync="customerCode"
      />
    </div>
    <div v-if="jobType === 'DC' && showView == 'outQuery'">
      <DCOutboundSearch
        :job-type.sync="jobType"
        :customer-code.sync="customerCode"
      />
    </div>
    <div v-if="jobType === 'DC' && showView == 'stock'">
      <DCInventorySearch
        :job-type.sync="jobType"
        :customer-code.sync="customerCode"
      />
    </div>
    <div v-if="jobType === 'CFS' && showView == 'statistic'">
      <CFSDataStatistics
        :job-type.sync="jobType"
        :customer-code.sync="customerCode"
      />
    </div>
    <div v-if="jobType === 'CFS' && showView == 'inQuery'">
      <CFSInboundSearch
        :job-type.sync="jobType"
        :customer-code.sync="customerCode"
      />
    </div>
    <div v-if="jobType === 'CFS' && showView == 'outQuery'">
      <CFSOutboundSearch
        :job-type.sync="jobType"
        :customer-code.sync="customerCode"
      />
    </div>
    <div style="height: 80px"></div>
    <div class="disclaimer">
      <div>
        <p>
          &nbsp;<img
            src="@/assets/wms/disclaimerIcon.svg"
            style="display: inline"
          />&nbsp;{{ $t('DomesticWarehousing.Disclaimer') }}
        </p>
      </div>
    </div>
    <ScriptCenter
      ref="scriptCenter"
      @success="$refs.SubscriptionSuccess.open()"
    />
    <SubscriptionSuccess ref="SubscriptionSuccess" />
  </div>
</template>
<script>
import DCDataStatistics from './modules/dcDataStatistics.vue';
import CFSDataStatistics from './modules/cfsDataStatistics.vue';
import DCInboundSearch from './modules/dcInboundSearch.vue';
import { USER_INFO } from '@/store/mutation-types';
import DCOutboundSearch from './modules/dcOutboundSearch.vue';
import DCInventorySearch from './modules/dcInventorySearch.vue';
import CFSInboundSearch from './modules/cfsInboundSearch.vue';
import CFSOutboundSearch from './modules/cfsOutboundSearch.vue';
import ScriptCenter from '@/components/scriptCenter.vue'
import SubscriptionSuccess from '@/components/subscriptionSuccess.vue'
import i18n from '@/i18n/i18n'
export default {
  components: {
    DCDataStatistics,
    CFSDataStatistics,
    DCInboundSearch,
    DCOutboundSearch,
    DCInventorySearch,
    CFSInboundSearch,
    CFSOutboundSearch,
    ScriptCenter,
    SubscriptionSuccess
  },
  data() {

    return {
      showView: 'statistic',
      customerCode: '',
      /** 线路筛选 */
      jobType: 'CFS',
      selectList: [
        { value: 'DC', label: i18n.t('DomesticWarehousing.DC') },
        { value: 'CFS', label: i18n.t('DomesticWarehousing.CFS') },
      ],
      lang: 'zh',
    };
  },
  computed: {
    userInfo() {
      return this.$ls.get(USER_INFO) || {};
    },
  },
  mounted() {
    this.lang = this.$ls.get('lang');
    if(this.$route.query.kind){      
      this.jobType = this.$route.query.kind;
     if(this.$route.query.fun) {      
      this.showView = this.$route.query.fun;
     }
    }
  },
  created() {
    this.customerCode =
      (this.$route.customerCode && this.$route.query.customerCode) ??
      this.userInfo.CACode; // this.userInfo.CACode // 'PT202108042031'// '201808003177'// '201808023676'
  },
  methods: {
    showScription() {
      const appModule = 'WMS_' + this.jobType
      console.log(appModule)
      this.$refs.scriptCenter.open(appModule)
    },
    changeJobType(){
      this.showView = 'statistic'
    }
  },
};
</script>
<style scoped>
.mtf1 {
  float: right;
  margin-top: -1px;
  border-top: #fff;
}
.page >>> .el-card.is-always-shadow {
  box-shadow: initial !important;
}
.page {
  padding: 10px;
  background: #f0f6fb;
  min-width: 1200px;
}
.page .card .header {
  float: left;
  display: flex;
  line-height: 22px;
  font-weight: bold;
}
.page .card .header .viewClass {
  color: #9c9c9c;
  cursor: pointer;
}
.page .card .header .showViewClass {
  color: #59b9d3;
  cursor: pointer;
}
.elSelect {
  width: 200px;
  margin-left: 10px;
  margin-right: 20px;
  border-radius: 8px;
}
.header {
  font-size: 16px;
}
.disclaimer {
  position: fixed;
  left: 210px;
  bottom: 0;
  right: 0;
  background: #f0f6fc;
  color: #8ca2bd;
  opacity: 0.85;
  font-size: 12px;
  height: 36px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  z-index: 3;
}
.scription-center {
  border: 1px solid #53a2b6;
  color: #53a2b6;
  height: 30px;
  line-height: 18px;
  border-radius: 4px;
  padding: 4px 16px;
  cursor: pointer;
  margin-top: 1px;
}
</style>
